import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private debug = environment.debug;
  public msgs: any[] = ['v. 1.0.10'];

  constructor() { }

  public log(msg: any, error: boolean = false) {
    if (error) {
      console.error(msg);
    } else {
      console.log(msg);
    };
    // if (this.debug) {
    //   error ? console.error(msg) : console.log(msg);
    //   const trace = Error().stack.split('\n').splice(2).join('\n\n');
    //   // const trace = Error().stack.split('\n').splice(2);
    //   console.log(trace)
    //   this.msgs.push(`${(new Date()).toISOString()}: ${error ? ' ERROR ' : ''} ${msg} : ${trace}`);
    // }
  };
}
